import React from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { resendVerificationEmail, logout } from 'actions';
import { resetCaptcha } from 'actions/registration';
import {
  actReloadData,
  actRequestUpdateOtp,
  actShowOtpModal,
  actSetOtpErrorMessage,
  actVerifyUpdateOtp,
  actSetStatusCode,
} from 'actions/setting/account';
import ConfirmEmailModal from 'pages/Register/ConfirmEmailModal';
import OtpModalDialog from './OtpModalDialog';
import styles from './style.css';

class AccountDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalEmail: false,
    };
    this.handleEmailBackClick = this.handleEmailBackClick.bind(this);
  }

  onClickVerifyPhone = () => {
    this.props.dispatch(
      actRequestUpdateOtp(this.props.accountData.phone, false)
    );
  };

  handleResendOtp = phone => {
    this.props.dispatch(actRequestUpdateOtp(phone, true));
  };

  handleBackClick = () => {
    this.props.dispatch(actShowOtpModal(false));
    this.props.dispatch(actSetOtpErrorMessage(null));
  };

  handleOtpSubmit = code => {
    const data = {
      code,
      request_id: this.props.otp.requestId,
    };
    this.props.dispatch(actSetStatusCode(null));
    this.props.dispatch(actVerifyUpdateOtp(data));
  };

  onClickVerifyEmail = () => {
    const { accountData } = this.props;
    this.setState({
      showModalEmail: true,
    });
    this.props.dispatch(
      change('confirmEmailModalForm', 'oldEmailAddress', accountData.email)
    );
    this.props.dispatch(
      change('confirmEmailModalForm', 'newEmailAddress', accountData.email)
    );
  };

  handleEmailBackClick = () => {
    this.setState({
      showModalEmail: false,
    });
  };

  handleEmailSubmit = values => {
    const { newEmailAddress, oldEmailAddress, captcha } = values;
    this.props.dispatch(
      resendVerificationEmail({
        oldEmail: oldEmailAddress,
        newEmail: newEmailAddress,
        captcha,
        resetCaptcha, // FIXME This looks like `resetCaptcha` from state, not action creator
      })
    );
    this.props.dispatch(logout());
  };

  componentWillReceiveProps(newProps) {
    if (newProps.otp.statusCode !== this.props.otp.statusCode) {
      if (newProps.otp.statusCode === 0) {
        this.props.dispatch(actReloadData());
      }
    }
  }

  render() {
    const { otp, dispatch, accountData, onClickUpdateProfile } = this.props;
    const otpVerifiedStatus = (
      <div className={`pull-right ${styles['mt-5']}`}>
        {accountData.isPhoneVerified === undefined ? (
          ''
        ) : accountData.isPhoneVerified ? (
          <div>
            <span className={styles.verified}>
              <i className="fa fa-check-circle" /> Verified
            </span>
          </div>
        ) : (
          <div>
            <span className={styles.unverified}>
              <i className="fa fa-info-circle" /> Unverified
            </span>
            <button
              className={`btn btn-link ${styles['btn-verify']}`}
              onClick={this.onClickVerifyPhone}
            >
              Verify now
            </button>
          </div>
        )}
      </div>
    );
    const emailVerifiedStatus = (
      <div className={`pull-right ${styles['mt-5']}`}>
        {accountData.isEmailVerified === undefined ? (
          ''
        ) : accountData.isEmailVerified ? (
          <div>
            <span className={styles.verified}>
              <i className="fa fa-check-circle" /> Verified
            </span>
          </div>
        ) : (
          <div>
            <span className={styles.unverified}>
              <i className="fa fa-info-circle" /> Unverified
            </span>
            <button
              className={`btn btn-link ${styles['btn-verify']}`}
              onClick={this.onClickVerifyEmail}
            >
              Verify now
            </button>
          </div>
        )}
      </div>
    );
    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>
            PERSONAL DETAILS
            <button
              className="btn btn-link pull-right"
              onClick={onClickUpdateProfile}
            >
              Edit
            </button>
          </div>
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            Name
            <div className={`pull-right ${styles['text-description']}`}>
              {accountData.fullName}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={`${styles['text-label']} ${styles['image-block']}`}>
            Phone
            <div className={`pull-right ${styles['text-description']}`}>
              {accountData.phone}
            </div>
            <br />
            {otpVerifiedStatus}
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={`${styles['text-label']} ${styles['image-block']}`}>
            Email
            <div className={`pull-right ${styles['text-description']}`}>
              {accountData.email}
            </div>
            <br />
            {emailVerifiedStatus}
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        {otp.showModal && (
          <OtpModalDialog
            onShow={otp.showModal}
            onHide={this.handleBackClick}
            phone={accountData.phone}
            otpError={otp.errorMessage}
            setOtpError={actSetOtpErrorMessage}
            handleOtpAction={actShowOtpModal}
            handleResendOtp={this.handleResendOtp}
            handleOtpSubmit={this.handleOtpSubmit}
          />
        )}
        {this.state.showModalEmail && (
          <ConfirmEmailModal
            show={this.state.showModalEmail}
            onHide={this.handleEmailBackClick}
            dispatch={dispatch}
            onSubmit={this.handleEmailSubmit}
            resetCaptcha={resetCaptcha}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    otp: {
      showModal: state.setting.account.otp_modal,
      requestId: state.setting.account.otp_request_id,
      errorMessage: state.setting.account.otp_error_msg,
      statusCode: state.setting.account.otp_status_code,
    },
  };
}

export default connect(mapStateToProps)(AccountDetail);
